export const MAX_ORG_TOTAL_COUNT = 10;
export const USER_ORGS_ROUTE = "/user_orgs";
